import { NEXT_IMAGE_DEVICE_SIZES, NextImageDeviceSizes } from './constants';
import { contentfulImageResponsiveUrl } from './contentfulImageResponsiveUrl';

export const buildContentfulImageSrcSet = (src: string, widths?: NextImageDeviceSizes): string => {
    if (/\.svg(\?|#|$)/i.test(src)) {
        return src;
    }

    return (widths || NEXT_IMAGE_DEVICE_SIZES)
        .map((width: number) => `${contentfulImageResponsiveUrl({ src, width })} ${width}w`)
        .join(', ');
};
